import styled from 'styled-components';
import { Col, Row, Typography } from 'antd';

import { Size } from '../../../hooks/useWindowSize';

export const Wrapper = styled.footer`
    background: rgba(37, 33, 41, 0.04);
`;

export const Link = styled(Typography.Link)`
    color: #6257d2;
`;

export const Container = styled.div`
    display: flex;
    max-width: 1172px;
    width: 100%;
    margin: 0 auto;
    padding: 2rem 24px 3rem 24px;
    box-sizing: border-box;
    flex-direction: column;

    @media (max-width: 992px) {
        display: flex;
        justify-content: space-between;
    }
`;

export const Contact = styled.div<{ size: string }>`
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
    justify-content: ${props =>
        props.size === Size.large ? 'flex-start' : 'center'};
    align-items: center;
    img {
        margin-right: 0.25rem;
    }
`;

export const Support = styled(Row)<{ size: string }>`
    margin-top: ${props => (props.size === Size.large ? '-100px' : '1.25rem')};
    justify-content: ${props =>
        props.size === Size.large ? 'flex-start' : 'center'};
`;

export const Payments = styled(Row)<{ size: string }>`
    margin-top: ${props => (props.size === Size.large ? '12px' : '1.25rem')};
    justify-content: ${props =>
        props.size === Size.large ? 'flex-start' : 'center'};
`;

export const Column = styled(Col)<{ size: string }>`
    display: flex;
    justify-content: ${props =>
        props.size === Size.large ? 'flex-start' : 'center'};
    text-align: ${props => (props.size === Size.large ? 'start' : 'center')};
`;
